import React, { useEffect, useState } from 'react';
import { Sparkles, X } from 'lucide-react';
import { telaNova } from '../config/novoVisual';

/**
 * Aviso de primeira visita a uma tela redesenhada.
 *
 * Aparece uma vez por tela, por navegador, e some ao ser dispensado. Não é
 * modal nem tour: quem já entendeu fecha e segue; quem não leu não fica preso.
 */

const chave = (rota) => `rf.novoVisual.visto:${rota}`;

const jaViu = (rota) => {
  try {
    return window.localStorage.getItem(chave(rota)) === '1';
  } catch {
    // localStorage lança em modo privado. Sem persistência, o aviso reaparece —
    // preferível a derrubar a tela por causa de um aviso.
    return false;
  }
};

const NovoVisualAviso = ({ rota }) => {
  const info = telaNova(rota);
  const [visivel, setVisivel] = useState(false);

  useEffect(() => {
    setVisivel(Boolean(info) && !jaViu(rota));
  }, [rota, info]);

  if (!info || !visivel) return null;

  const dispensar = () => {
    setVisivel(false);
    try {
      window.localStorage.setItem(chave(rota), '1');
    } catch {
      /* não persistiu; a sessão atual segue sem o aviso */
    }
  };

  return (
    <div className="rf-note" role="status">
      <Sparkles size={18} className="rf-note__icon" aria-hidden="true" />
      <div className="rf-note__body">
        <strong>Esta tela mudou de visual.</strong> {info.resumo}
      </div>
      <button
        type="button"
        className="rf-note__dismiss"
        onClick={dispensar}
        aria-label="Entendi, não mostrar de novo"
        title="Entendi"
      >
        <X size={16} />
      </button>
    </div>
  );
};

export default NovoVisualAviso;
